import { useMemo } from 'react';

import { DataTable, type TableColumn } from '@/src/ui';
import type { ExamAssignmentDTO } from '../TeacherDashboardDTOs';
import { ReportHeaderStyle, ReportCellStyle, utcToLocal, formatOptions } from '@/src/utils';

interface ExamAssignmentsTableProps {
    data: Array<ExamAssignmentDTO>;
}

export default function ExamAssignmentsTable(props: ExamAssignmentsTableProps) {
    const { data } = props;

    const columns = useMemo<TableColumn[]>(() => {
        return [
            {
                dataKey: 'examName',
                header: 'Name',
                align: 'left',
                allowSort: true,
                emptyValue: '-',
                headerSx: ReportHeaderStyle,
                cellSx: ReportCellStyle,
            },
            {
                dataKey: 'dateRange',
                header: 'Date Range',
                align: 'left',
                width: 100,
                emptyValue: '-',
                headerSx: ReportHeaderStyle,
                cellSx: ReportCellStyle,
                formatter: (row) => {
                    const from = row.fromDate
                        ? utcToLocal(row.fromDate)?.toLocaleString(undefined, formatOptions)
                        : '--';
                    const to = row.toDate
                        ? utcToLocal(row.toDate)?.toLocaleString(undefined, formatOptions)
                        : '--';

                    return `${from} - ${to}`;
                },
            },
        ];
    }, []);

    return (
        <>
            <DataTable
                data={data}
                columns={columns}
                tableName="Assessments"
                alternatingRowColor
                rowsPerPageInitial={5}
                rowsPerPageList={[5]}
                defaultSortColumn="examName"
                defaultSortDirection="asc"
            />
        </>
    );
}
